var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('div',{staticClass:"centered"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_c('br'),_c('br'),_vm._v(" Verifying ")])])}
var staticRenderFns = []

export { render, staticRenderFns }